import React from "react";
import CheckBox from "../CheckBox";
import styles from "./styles.module.less";

interface IProps {
  verbose: boolean;
  id: string;
}

const AvatarWithCheck: React.FC<IProps> = ({ children, verbose, id }) => {
  return (
    <div className={styles.container}>
      {children}
      <CheckBox verbose={verbose} id={id} />
    </div>
  );
};

export default AvatarWithCheck;
